import React, { useState } from 'react';
import { Container } from './styles';

import Logo from '~/assets/logos/Logo ManyFlows Vertical.png';

function PainelPDF({ data, ...rest }) {  
  return (
    <Container {...rest}>
      <div className="barra-sup"></div>
      <div className="header">
        <img src={Logo} alt="Logo" />
        <div class="text">
          <p class="titulo">Gestor Serviço</p>
          <p class="titulo-relatorio">Relatório do Dashboard</p>
          <p class="titulo-data">Relatório gerado em {new Date().toLocaleString()}</p>
        </div>
      </div>
      <div className="body">
        <div className="mid">
          <div className="col">
            <div className="linha">
              <p className="titulo">Pesquisa:</p>
              <p className="valor">{data?.tituloPesquisa}</p>
            </div>
            <div className="linha">
              <p className="titulo">Período:</p>
              <p className="valor">{data?.tituloPeriodo}</p>
            </div>
          </div>
          <div className="col rigth">
            <div className="linha">
              <p className="titulo">Turnos:</p>
              <p className="valor">{data?.tituloTurno}</p>
            </div>
            <div className="linha">
              <p className="titulo">Centro de Custo:</p>
              <p className="valor">{data?.listaCCs}</p>
            </div>
          </div>
        </div>
      </div>
    </Container >
  );
};

export default PainelPDF;